import axios from "axios";
import { get_access_token } from "./get_access_token"

export const updateSettings = async (userId,userData) => {
  const access_token = await get_access_token(userId.user);
  const apiUrl = process.env.REACT_APP_API_URL;

  let data = await axios({
    method: "post",
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
      "Content-Type": "application/x-www-form-urlencoded",
      "Authorization": access_token,
  },
    url: `${apiUrl}/api/profile/update_settings`,
    data: {
      user: userData
    },
  });

  // user_name: "",
  //   email: ""

  const result = data.data

  return result;
};
